export default function Title(){
    return(
        <div className="bg-background">
            <div className="mx-10">
                <div className="pt-10 lg:mx-20">
                    <h2 className="text-6xl not-italic font-bold text-white font-title leading-10">Marketplace</h2>
                    <p className="mt-6 text-lg leading-8 text-white">
                      Secure Your Seats: Purchase Tickets listed by your fellow enthusiasts
                    </p>
                </div>
            </div>
        </div>
    )
}